module.exports = __webpack_public_path__ + "img/interventions.90e9b017.png";